import axios from 'axios';

// 设置 API 的基础 URL
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axios;

// 获取期权持仓列表
// params 支持以下参数：
// - symbol: 标的代码
// - status: 持仓状态（OPEN/PARTIAL_CLOSED/CLOSED）
// - date: 日期
// - strategy: 策略（BREAKOUT/DOOMSDAY/CUSTOM）
export const getOptionPositions = async (params) => {
    const response = await axios.get('/api/option_positions', { params });
    return response.data;
};

// 获取期权交易历史
export const getTradeHistory = async (positionId) => {
    const response = await axios.get(`/api/option_positions/${positionId}/history`);
    return response.data;
};

// 手动清仓 API
export const closePosition = async (positionId) => {
    const response = await axios.post(`/api/option_positions/${positionId}/close`);
    return response.data;
};

// 减仓一半 API
export const reducePositionHalf = async (positionId) => {
    const response = await axios.post(`/api/option_positions/${positionId}/reduce_half`);
    return response.data;
};

// 更新股票止损价 API
export const updateStockStopLossPrice = async (positionId, stockStopLossPrice) => {
    const response = await axios.put(`/api/option_positions/${positionId}/stock_stop_loss`, {
        stock_stop_loss_price: stockStopLossPrice
    });
    return response.data;
};

// 手动下单 API
// 参数:
// - symbol: 标的代码
// - option_type: 期权类型 (call/put)
export const createManualOrder = async (orderData) => {
    const response = await axios.post('/api/manual_order', orderData);
    return response.data;
};